<template>
    <section class="app-main">
        
        <el-tabs type="border-card" style="margin-top:30px;">

            <el-tab-pane label="分类管理">
                <classify section="8" :classify.sync="classify" />
            </el-tab-pane>
            <el-tab-pane label="商品管理">
                <goods section="8" :classify.sync="classify" />
            </el-tab-pane>
        </el-tabs>

    </section>
</template>



<script>

import Classify from './../components/class'
import Goods    from './../components/goods'
export default {
    components: { Classify, Goods },
    data() {
        return {
            classify: []
        }
    },
    methods: {
        
        
    },
    created(){
        // this.getData()
    }
}
</script>

<style lang="less" scoped>
section {
    /deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item {
        font-size: 16px;
    }
}
</style>
